/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react'
import {
  Col, Input, Tabs, List, Avatar, Button, Skeleton,
} from 'antd'
import { compose, withApollo } from 'react-apollo'
import { useQuery } from '@apollo/react-hooks'

import registrationQuery from '../graphql/queries/registrationProfile'
import racesQuery from '../graphql/queries/races'

import {
  Racecomponents,
  RaceHeadercomponents,
  RaceRowcomponents,
  RaceTextcomponents,
  RaceSearchcomponents,
} from './styled-components/raceStyled'

// import AFM from '../img/AFM-25.png'
// import runer from '../img/runer-silhouette-running-fast.png'
const { Search } = Input
const { TabPane } = Tabs

function callback(key) {
  console.log(key)
}

const ProfileContainer = ({ client }) => {
  // let { sort, status } = this.state
  const [status] = useState('')
  const [loading] = useState(false)
  const _operators = {
    status: {
      in: ['', 'all'].includes(status) ? ['paid', 'draft', 'submitted', 'payment_verifying', 'accepted', 'rejected'] : status,
    },
  }
  // const limit = 100
  const start = 3
  const skip = 0
  const sort = '_ID_DESC'
  const filter = { _operators }
  const registrations = useQuery(registrationQuery, {
    client,
    fetchPolicy: 'cache',
    variables: {
      filter, limit: start, skip, isVirtual: false,
    },
  })

  const recommendations = useQuery(racesQuery, {
    client,
    fetchPolicy: 'cache',
    variables: {
      sort, filter: { isVirtual: false }, limit: start,
    },
  })
  const onLoadMore = (e) => {
    e.preventDefault()
    registrations.fetchMore({
      query: registrationQuery,
      variables: { skip: registrations.data.registrationProfile.length, limit: registrations.variables.limit, isVirtual: registrations.variables.isVirtual },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newRegistrations = fetchMoreResult.registrationProfile
        return {
          registrationProfile: [...previousResult.registrationProfile, ...newRegistrations],
        }
      },
    })
  }
  const onRecommendataionLoadMore = (e) => {
    e.preventDefault()
    recommendations.fetchMore({
      query: racesQuery,
      variables: { skip: recommendations.data.races.length, limit: recommendations.variables.limit },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newRecommendations = fetchMoreResult.races
        return {
          races: [...previousResult.races, ...newRecommendations],
        }
      },
    })
  }
  const loadMore = !loading ? (
    <div
      style={{
        textAlign: 'center',
        marginTop: 12,
        height: 32,
        lineHeight: '32px',
      }}
    >
      <Button onClick={onLoadMore}>See more... </Button>
    </div>
  ) : null
  const loadMoreRecommendataion = !loading ? (
    <div
      style={{
        textAlign: 'center',
        marginTop: 12,
        height: 32,
        lineHeight: '32px',
      }}
    >
      <Button onClick={onRecommendataionLoadMore}>See more... </Button>
    </div>
  ) : null
  return (
    <Racecomponents>
      <RaceHeadercomponents>
        <Col>
          <RaceRowcomponents>
            <Col>
              <RaceTextcomponents>
                Race
              </RaceTextcomponents>
            </Col>
            <RaceSearchcomponents>
              <Search
                placeholder="ค้นหางานวิ่ง"
                onSearch={value => console.log(value)}
                // size="large"
                style={{ width: '300px', borderRadius: '50px' }}
              />
            </RaceSearchcomponents>
          </RaceRowcomponents>
        </Col>
        {/* <Col style={{ border: '1px solid rgba(153, 153, 153, 0.26)', width: '600px' }}/>  */}
        <Col style={{ textAlign: 'left' }}>
          <Tabs defaultActiveKey="1" onChange={callback} type="card">
            <TabPane tab="งานวิ่งของฉัน" key="1">
              <List
                className="demo-loadmore-list"
                loading={registrations.loading}
                itemLayout="horizontal"
                loadMore={loadMore}
                dataSource={!registrations.loading ? registrations.data.registrationProfile : []}
                renderItem={item => (
                  <List.Item
                    actions={[<a key="list-loadmore-edit">edit</a>, <a key="list-loadmore-more">more</a>]}
                  >
                    <Skeleton avatar title={false} loading={item.loading} active>
                      <List.Item.Meta
                        avatar={
                          <Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />
                        }
                        title={<a href={'https://race.thai.run/'.concat(item.event.slug)}>{item.event.name.en}</a>}
                        description="Placeholder description"
                      />
                      {/* <div>content</div> */}
                    </Skeleton>
                  </List.Item>
                )}
              />
            </TabPane>
            <TabPane tab="งานวิ่งที่น่าสนใจ" key="2">
              <List
                className="demo-loadmore-list"
                loading={recommendations.loading}
                itemLayout="horizontal"
                loadMore={loadMoreRecommendataion}
                dataSource={!recommendations.loading ? recommendations.data.races : []}
                renderItem={item => (
                  <List.Item
                    actions={[<a key="list-loadmore-edit">edit</a>, <a key="list-loadmore-more">more</a>]}
                  >
                    <Skeleton avatar title={false} loading={item.loading} active>
                      <List.Item.Meta
                        avatar={
                          <Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />
                        }
                        title={<a href={'https://race.thai.run/'.concat(item.event.slug)}>{item.event.name.en}</a>}
                        description="Placeholder description"
                      />
                      {/* <div>content</div> */}
                    </Skeleton>
                  </List.Item>
                )}
              />
            </TabPane>
          </Tabs>
        </Col>
      </RaceHeadercomponents>
    </Racecomponents>
  )
}

export default compose(withApollo)(ProfileContainer)



// WEBPACK FOOTER //
// ./src/components/race.js